import React from 'react';
import { CloseableModal } from '../../../../components/CloseableModal';
import { ModalBody } from './ModalBody';
import { SuccessfulModalBody } from './SuccessfulModalBody';

interface PropTypes {
  applicationId: number;
  candidateName: string;
  jobName?: string;
  isOpen: boolean;
  showConfirmationModal: boolean;
  filterRejectedBy?: string;
  preSelectedRejectReasonId?: number;
  onReject: (succeeded: boolean, rejectedReson?: string) => void;
  onClose: (sendEmail: boolean) => void;
  setPreSelectedRejectReasonId?: (preSelectedRejectReasonId: number) => void;
}

export function RejectCandidateStageModal(props: PropTypes) {
  return (
    <CloseableModal
      className='modal-dialog-centered'
      onClose={() => props.onClose(false)}
      isOpen={props.isOpen}
      size='md'
      keyboard
      backdrop
      headerTitle='Reject Candidate'
      bodyChildren={
        props.showConfirmationModal ? (
          <SuccessfulModalBody
            candidateName={props.candidateName}
            jobName={props.jobName}
            onClose={props.onClose}
          />
        ) : (
          <ModalBody
            applicationIds={[props.applicationId]}
            description={
              <>
                Reject <b>{props.candidateName}</b> for the{' '}
                <b>{props.jobName}</b> job?
              </>
            }
            filterRejectedBy={props.filterRejectedBy}
            preSelectedRejectReasonId={props.preSelectedRejectReasonId}
            setPreSelectedRejectReasonId={props.setPreSelectedRejectReasonId}
            onClose={props.onReject}
          />
        )
      }
    />
  );
}
